import React from 'react';

export default function StatusJourney() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Status Journey</h1>
      <p className="text-gray-500">Halaman Status Journey</p>
    </div>
  );
}
